<div *ngIf="visible" class="flex flex-col gap-3 p-5 bg-gray-50 rounded-xl border border-gray-200">
  <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-1">Actions</h3>

  <button
    *ngIf="permissions.includes('APPLICATION_APPROVE')"
    (click)="approve.emit()"
    class="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium
           bg-emerald-600 text-white hover:bg-emerald-700 transition-colors">
    <mat-icon class="text-[18px] !w-[18px] !h-[18px]">check_circle</mat-icon>
    Approve
  </button>

  <button
    *ngIf="permissions.includes('APPLICATION_QUERY') "
    (click)="query.emit()"
    class="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium
           bg-amber-500 text-white hover:bg-amber-600 transition-colors">
    <mat-icon class="text-[18px] !w-[18px] !h-[18px]">help_outline</mat-icon>
    Query
  </button>

  <button
    *ngIf="permissions.includes('APPLICATION_REJECT')"
    (click)="reject.emit()"
    class="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium
           bg-red-600 text-white hover:bg-red-700 transition-colors">
    <mat-icon class="text-[18px] !w-[18px] !h-[18px]">cancel</mat-icon>
    Reject
  </button>
</div>
